import React, { useState } from "react";
import { Button, Grid, List, ListItem, Box, ListItemText } from "@mui/material";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import ListItemIcon from "@mui/material/ListItemIcon";
import useScrollToTop from "../../../components/CustomHooks/useScrollToTop";

function Confirm({ prevStep, goToStep, handleConfirm, values }) {
  useScrollToTop();

  const { tripid, permitNbr, portcd, mnkfshOvrFlg } = values;
  const [isDisabled, setIsDisabled] = useState(false);

  const _next = (event) => {
    event.preventDefault();
    const close_trip_hail = {
      offloading_port: portcd.id,
      mnkfsh_ovrgflg: mnkfshOvrFlg,
    };
    console.log("Close Trip Hail", close_trip_hail);
    setIsDisabled(true);
    handleConfirm(close_trip_hail);
  };

  const _cancel = (event) => {
    event.preventDefault();
    if (isDisabled) {
      setIsDisabled(false);
    }
    prevStep();
  };

  const handleClick = (step) => {
    goToStep(step);
  };

  return (
    <>
      <Grid
        container
        spacing={2}
        align="center"
        justifyContent="center"
        alignItems="center"
      >
        <Grid item xs={12} md={4}>
          <List>
            <ListItem style={{ paddingLeft: "7px" }} divider>
              <ListItemText primary={`Vessel Permit: ${permitNbr}`} />
            </ListItem>
            <ListItem style={{ paddingLeft: "7px" }} divider>
              <ListItemText primary={`Trip Id: ${tripid}`} />
            </ListItem>
            <ListItem
              button
              onClick={() => handleClick(1)}
              style={{ paddingLeft: "7px" }}
              divider
            >
              <ListItemText primary={`Arrival Port: ${portcd.name}`} />
              <ListItemIcon style={{ minWidth: "0px" }}>
                <NavigateNextIcon />
              </ListItemIcon>
            </ListItem>
            <ListItem
              button
              onClick={() => handleClick(2)}
              style={{ paddingLeft: "7px" }}
              divider
            >
              <ListItemText
                primary={`Monkfish trip limit overage? ${
                  mnkfshOvrFlg === "true" ? "Yes" : "No"
                }`}
              />
              <ListItemIcon style={{ minWidth: "0px" }}>
                <NavigateNextIcon />
              </ListItemIcon>
            </ListItem>
          </List>
        </Grid>
      </Grid>
      <Box display="flex" justifyContent="center" m={1} p={1}>
        <Box p={1}>
          <Button variant="contained" className="warningBtn" onClick={_cancel}>
            Back
          </Button>
        </Box>
        <Box p={1}>
          <Button
            variant="contained"
            className={isDisabled ? "disabledBtn" : "successBtn"}
            disabled={isDisabled}
            onClick={_next}
          >
            Confirm and Submit
          </Button>
        </Box>
      </Box>
    </>
  );
}

export default Confirm;
